import {TextField, TextFieldProps} from '@mui/material'
import {styled} from '@mui/system'
import {colors} from '@/constants'

// @ts-ignore
export interface CenteredInputProps extends TextFieldProps {
  placeholderalign?: string
  borderBottom?: string
  textalign?: string
  disabledcolor?: string
}

const Input = styled(TextField)<CenteredInputProps>(
  ({placeholderalign, borderBottom, textalign, disabledcolor}) => `
  & .MuiInput-input {
  text-align: ${textalign || 'left'};
  overflow: hidden;
  }
  & .MuiFormHelperText-root {
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 500;
    color: rgba(139, 139, 147, 0.8);
  }
  & .MuiInputBase-root {
    color: ${colors.white};
    font-size: 20px;
    font-weight: 400;
    &:before {
      border-bottom: ${borderBottom || `1px solid ${colors.lightBrown}`};
    }
    &:hover:not(.Mui-disabled, .Mui-error):before {
      border-bottom: ${borderBottom || `1px solid ${colors.lightBrown}`} !important;
    }
    & .MuiPaper-root {
    color: ${colors.white};
      background: black;
    }
  }
  & .Mui-disabled {
    -webkit-text-fill-color: ${disabledcolor ? disabledcolor : colors.gray}!important;
    }
  & .MuiInputBase-root .MuiInput-input {
  color: ${colors.white};
    &:focus {
      background: transparent!important;
    }
    &:disabled {
    -webkit-text-fill-color:${colors.white};
    }
    &::placeholder {
    color: ${colors.white};
     text-align: ${placeholderalign || 'left'};
     color: #73716D;
    padding-left: 10px;
    font-weight: 500;
    font-size: 20px;
    line-height: 24.38px;
    color: #B0B0B0;
        }
    color: white;
  }
  & .MuiFormHelperText-root {
  color: ${colors.orange};
  position: absolute;
  bottom: -27px;
  }
  input:-webkit-autofill {
  color: ${colors.white};
   -webkit-text-fill-color: ${colors.white}!important;
  -webkit-text-fill-color: #ссс;
  font-size: 20px;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset;
  transition: background-color 5000s ease-in-out 0s;
  background: transparent;
}
`
)

export default Input
